module.exports = __webpack_public_path__ + "img/team-bg.3f6355a3.svg";